import React from "react";
import { User } from "lucide-react";
import CustomerAutofill from "./CustomerAutofill";

const CustomerSection = ({ formData, setFormData, customers, selectCustomer, onOpenCustomer }) => (
  <div className="space-y-3 sm:space-y-4">
    <div className="flex items-center gap-2 text-[#FFCC00]">
      <User className="w-4 h-4" />
      <span className="text-sm font-medium">Customer Information</span>
    </div>
    <CustomerAutofill
      values={formData}
      onChange={(key, value) => setFormData((prev) => ({ ...prev, [key]: value }))}
      customers={customers}
      onSelectCustomer={selectCustomer}
      onOpenCustomer={onOpenCustomer}
      onUnlink={() =>
        // Clear everything the link autofilled so a newly typed customer
        // can't silently inherit the previous customer's identity/address.
        setFormData((prev) => ({
          ...prev,
          customer_id: "", customer_name: "", customer_phone: "",
          customer_phone2: "", customer_email: "",
          customer_address: "", address_city: "", address_state: "", zip_code: "",
        }))
      }
      inputClassName="input-glass"
    />
  </div>
);

export default CustomerSection;
